import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Mail, Phone, MapPin } from 'lucide-react';
import colors from '../constants/colors';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <Section>
          <SectionTitle>VAST</SectionTitle>
          <SectionText>
            Virtual Assistant - Strategy & Tech: Professional services for businesses and entrepreneurs.
          </SectionText>
        </Section>

        <Section>
          <SectionTitle>Quick Links</SectionTitle>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/portfolio">Portfolio</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </Section>

        <Section>
          <SectionTitle>Contact Info</SectionTitle>
          <ContactItem>
            <Mail size={16} color={colors.accent} style={{ marginRight: 8 }} />
            <ContactText>bhavaya.vast@outlook.com</ContactText>
          </ContactItem>
          <ContactItem>
            <Phone size={16} color={colors.accent} style={{ marginRight: 8 }} />
            <ContactText>8764704519</ContactText>
          </ContactItem>
          <ContactItem>
            <MapPin size={16} color={colors.accent} style={{ marginRight: 8 }} />
            <ContactText>India</ContactText>
          </ContactItem>
        </Section>
      </FooterContent>

      <Divider />

      <Copyright>
        <CopyrightText>
          © {new Date().getFullYear()} VAST - Virtual Assistant Strategy & Tech. All rights reserved.
        </CopyrightText>
      </Copyright>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: ${colors.primary};
  padding-top: 40px;
  padding-bottom: 20px;
  border-top: 1px solid ${colors.gray};
`;

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 16px;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Section = styled.div`
  min-width: 200px;
  margin-bottom: 24px;
  flex: 1;
  
  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.secondary};
  margin-bottom: 16px;
`;

const SectionText = styled.p`
  font-size: 14px;
  color: ${colors.lightText};
  line-height: 20px;
`;

const NavLink = styled(Link)`
  display: block;
  font-size: 14px;
  color: ${colors.lightText};
  margin-bottom: 8px;
  text-decoration: none;
  
  &:hover {
    color: ${colors.accent};
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const ContactText = styled.span`
  font-size: 14px;
  color: ${colors.lightText};
`;

const Divider = styled.div`
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 20px 16px;
`;

const Copyright = styled.div`
  text-align: center;
`;

const CopyrightText = styled.p`
  font-size: 14px;
  color: ${colors.lightText};
`;

export default Footer;
